import { FC } from 'react';
import { cn } from '@new/lib';
import { ChatMessage } from '../../types';
import { formatMessageTimestamp } from '../../lib/helpers';

interface ChatMessageBubbleProps {
  message: ChatMessage;
  isOwn: boolean;
  showTimestamp?: boolean;
}

export const ChatMessageBubble: FC<ChatMessageBubbleProps> = ({
  message,
  isOwn,
  showTimestamp = true,
}) => {
  return (
    <div
      className={cn(
        'flex flex-col gap-1 max-w-[70%] min-w-0',
        isOwn ? 'items-end ml-auto' : 'items-start'
      )}
    >
      <div
        className={cn(
          'px-4 py-2.5 rounded-2xl [font-size:var(--fs-p4)]! text-(--neutral-black-NB1000) leading-relaxed break-words [overflow-wrap:anywhere]!',
          isOwn ? 'bg-(--secondary-B100) rounded-br-md' : 'bg-(--neutral-white-NW800) rounded-bl-md'
        )}
      >
        {message.text}
      </div>
      {showTimestamp && (
        <span className="[font-size:var(--fs-l6)]! text-(--neutral-black-NB500) px-1">
          {formatMessageTimestamp(message.createdAt)}
        </span>
      )}
    </div>
  );
};
